/* set jquery globals */
const $ = window.jQuery;
const jQuery = window.jQuery;

$(document).ready(function(){

    var map,
      geocoder,
      markers = [],
      infowindow;
      
    if(window.google) {
      geocoder = new google.maps.Geocoder(),
      infowindow = new google.maps.InfoWindow();
    }
    
    function init() {
      // create and center our map
      map = new google.maps.Map(document.getElementById('map'), {
        center: {lat: 33.7676931, lng: -84.4906436},
        zoom: 2
      });
      
      // run through locations array
      locations.forEach(function(location, index) {
        var name = location.name,
            coords,
            url = location.url,
            addr = location.address,
            latLng;
        
        // create the html to populate the info window 
        var infoWindowHtml = '<h4><a href="' + url + '">' + name + '</a></h4>' + location.address;
        // If we have coordinates already
        if(location.lat_long.trim().length !== 0) {
          // create an array out of our coordinate string
          coords = location.lat_long.trim().split(',');
          // convert that array to a google map compatible object
          latLng = new google.maps.LatLng(coords[0], coords[1]);
          // create marker and add event listener
          addMarker(latLng, infoWindowHtml);
        }
        else {
          // use geocoder to convert addresses to map compatible lat and lng obj
          geocoder.geocode( { 'address': addr}, function(results, status) {
            if (status == 'OK') {
              // get our google compatible obj
              latLng = results[0].geometry.location;
              // create marker and add event listener
              addMarker(latLng, infoWindowHtml);
            } else {
              //console.log('Geocode was not successful for the following reason: ' + status);
            }
          });
        }
      });
    }
    
    function addMarker(point, infoWindowHtml) {
      // create our marker on the map
      var marker = new google.maps.Marker({
        position: point,
        map: map
      });
      // add event listener
      google.maps.event.addListener(marker, 'click', infoCallback(infoWindowHtml, marker));
      markers.push(marker);
    }
    
    function infoCallback(infoWindowHtml, marker) {
      return function() {
        // close current infowindow
        infowindow.close();
        // update the content of the infowindow before opening it
        infowindow.setContent(infoWindowHtml);
        // reopen infowindow with updated content
        infowindow.open(map, marker);
      };
    }
    
    if(document.getElementById('map')) {
      init();
    }
});
